
export default function ServicesOverview() {
  const services = [
    {
      icon: 'ri-user-search-line',
      title: 'AI Intake & Lead Qualification',
      description: 'Automated client intake systems that capture, qualify, and route new inquiries with speed and accuracy.'
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Handling & Missed-Call Recovery',
      description: 'Ensure no potential client goes unanswered with intelligent call routing and follow-up systems.'
    },
    {
      icon: 'ri-flow-chart',
      title: 'Case Workflow Automation',
      description: 'Streamline internal processes across matters, documents, and communications.'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Client Communication Intelligence',
      description: 'Structured, compliant communication systems that improve responsiveness and client satisfaction.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Reporting & Performance Dashboards',
      description: 'Clear operational visibility into firm performance, response times, and intake efficiency.'
    }
  ];

  return (
    <section id="services" className="bg-[#0E1A2B] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl text-[#F7F5F2] mb-6">
            Intelligent systems for modern law firms
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-[#F7F5F2] p-10 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-[#C8A14A]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0E1A2B] mb-4 leading-tight">
                {service.title}
              </h3>
              <p className="text-[#1C1C1E] leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
